module.exports = __webpack_public_path__ + "static/media/testimonial3.ea4ec826.jpg";